"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosAdMediaSchema = void 0;
const zod_1 = require("zod");
const id_schema_1 = require("../../../common/id.schema");
/**
 * Ad media library entry — single-write (immutable after upload), so no updatedAt.
 */
exports.APosAdMediaSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    mediaId: id_schema_1.EntityIdSchema,
    mediaType: zod_1.z.enum(['video', 'image']),
    filename: zod_1.z.string().min(1).max(255),
    s3Key: zod_1.z.string().min(1),
    cdnUrl: zod_1.z.string().url(),
    sizeBytes: zod_1.z.number().int().nonnegative(),
    contentType: zod_1.z.string().min(1),
    width: zod_1.z.number().int().positive().optional(),
    height: zod_1.z.number().int().positive().optional(),
    durationSeconds: zod_1.z.number().nonnegative().optional(),
    uploadedBy: zod_1.z.string().min(1),
    createdAt: zod_1.z.number().describe('Unix timestamp in milliseconds'),
});
//# sourceMappingURL=ad-media.schema.js.map